import styled from 'styled-components';

const Title = styled.div`
    font-size: 22px;
    font-weight: 600;
    padding: 15px 0px;
    min-height: 60px;

    div {
        font-size: 16px;
        font-weight: 300;
        color: #999;
    }
`;

export default Title;
